import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Observable , of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router,RouterModule  } from '@angular/router';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelfVerificationService } from '../service/self-verification.service';
export interface person {
  companyEmail:string,  ​
  companyName:string,  ​
  companyNationalId:string,  ​
  email:string,  ​
  employeeType:string,  ​
  firstName:string,  ​
  lastName:string,  ​
  mdmid:string,  ​
  nationalId:string,  ​
  nationality:string,  ​
  oneUp: any,  ​
  organizationalLevel:string,  ​
  passportNumber: any,  ​
  personnelArea:string,  ​
  personnelSubareaName:string,  ​
  phoneNumber:string,  ​
  title: string
}


@Component({
  selector: 'app-visitor-verification',
  templateUrl: './visitor-verification.component.html',
  styleUrls: ['./visitor-verification.component.css']
})
export class VisitorVerificationComponent implements OnInit {
  ApproverId= new UntypedFormControl([Validators.required])
  options:any[];
  filteredOptions: Observable<any>;
  verificationExternal:any[];

   //---people for mat autocomplete
   peoples=  [];
   searchPeople :string;
   personFound = false;
   personNotFound = false;
   person: any=[];
   mdmId: string;
  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private dataApi: SelfVerificationService,
    public dialog: MatDialog,
  ) { }

  searchSubject = new Subject<string>();

  ngOnInit() {
    this.initSearchPipeline();
  }
  
  ngOnDestroy() {
    this.searchSubject.complete();
  }

    initSearchPipeline(): void {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(nameSearch => {
        if(nameSearch.trim() === '') {
          this.peoples = [];
          this.spinner.hide();
          return [];
        }
        this.spinner.show();
        this.person = [];
        this.personFound = true;
        this.personNotFound = false;
        return this.dataApi.getSearchVisitor(nameSearch).pipe(
          catchError(err => {
            this.peoples = [];
            this.spinner.hide();
            return of([]);
          })
        );
      })
    ).subscribe({
      next: (data: any) => {
        if(data == null || data == undefined || data.length == 0) {
          this.peoples = [];
          this.personNotFound = true;
          this.spinner.hide();
        } else {
          let peoples = [];
          data.forEach(element => {
            if(element.email=='' || element.email==null)
              element.email = element.companyEmail;
            peoples.push(element);
          });
          this.peoples = peoples;
        }
        this.spinner.hide();
      },
      error: (err: any) => {
        this.peoples = [];
        this.spinner.hide();
      }
    });

  }

  getlang(){
    return sessionStorage.getItem('lang');
  }

  searchPerson(event: Event) {
    const nameSearch = (event.target as HTMLInputElement).value;
    this.searchSubject.next(nameSearch);
  }

  // searchPerson(event: Event){ // search person by letter
  //   this.spinner.show()
  //   this.person=[];
  //   this.personFound =true;
  //   this.personNotFound=false;
  //   const nameSearch = (event.target as HTMLInputElement).value;
  //   if(nameSearch!= ''){
  //     this.dataApi.getSearchVisitor(nameSearch).subscribe(
  //       (data: any)=>{
  //         if(data==null || data==undefined || data.length==0){
  //           this.peoples= [];
  //           this.personNotFound=true;
  //           this.spinner.hide()
  //         }else{
  //           let peoples = [];
  //           data.forEach(element => {
  //             if(element.email=='' || element.email==null)
  //               element.email = element.companyEmail;
  //             peoples.push(element);
  //           });
  //           this.peoples=  peoples;
  //           this.spinner.hide()
  //         }
  //       },
  //       (err: any)=>{
  //         this.peoples= [];
  //         this.spinner.hide()
  //       }
  //     );
  //   }else{
  //     this.peoples= [];
  //     this.spinner.show()
  //   }

  // }

  addpeopleMdmidFilterValue(option){
    this.person= option;
  }

  redirect(value){
    this.mdmId = value.mdmid;
    this.router.navigate(['visitor-accesses']);
  }


}
